import { utils } from '../../Foundation';

export class DatatableBody {
    constructor(inputSettings) {
        this._refs = {
            el: inputSettings.el,
            table: inputSettings.table,
            currentPage: inputSettings.currentPage,
            state: {
                data: inputSettings.state.data
            },
            settings: inputSettings.settings,
            customLabels: inputSettings.customLabels,
            eventList: inputSettings.eventList
        }

        this._createTableBody();
    }

    async _createTableBody() {
        const filteredList = await this._filterListOfItems();
        const tbodyElement = utils.createElement('tbody', {
            'class': 'datatable__body',
        });
        
        await filteredList.forEach(item => {
            let listOfKeys = Object.keys(this._refs.state.data[0]);
            if(this._refs.customLabels) {
                if(this._refs.customLabels.length > 0) {
                    listOfKeys = this._refs.customLabels;
                }
            }
            const trElement = utils.createElement('tr', {
                'class': 'datatable__item d-flex',
            });
            listOfKeys.forEach(key => {
                if(typeof this._refs.eventList.customBody === 'function') {
                    this._refs.eventList.customBody(trElement, key, item);
                } else {
                    // Set contents from Response object
                    utils.createElement('td', {
                        'class': 'datatable__cell',
                        'innerText': item[key]
                    }, trElement);
                }
            })
            tbodyElement.append(trElement);
        })
        this._refs.table.append(tbodyElement);
    }

    async _filterListOfItems() {
        let startItem = 0;
        let endItem = this._refs.settings.pageSize.current * this._refs.currentPage;
        // Set item start position
        if (this._refs.currentPage > 1) {
            startItem = this._refs.settings.pageSize.current * (this._refs.currentPage - 1);
        }
        // Filter the list to display 10 / 25 / 50 items
        const filterList = await this._refs.state.data.filter(
            (data, i) => i < endItem && startItem <= i
        );
        return filterList;
    }
}